<template>
  <div class="failureAccess">
    <img
      :src="this.$store.state.commonForms.url"
      alt=""
      class="img"
    />
    <p class="congratulation">恭喜您获得“{{ this.$store.state.commonForms.orgName }}”提供的授信额度</p>
    <p style="font-size:25px">
      {{ this.$store.state.commonForms.creditAmount }}元
    </p>
    <Button
      :text="draw"
      :type="danger"
      class="draw"
      :click="gotoDownloadApp"
    />
    <OnlyYiLianInfo :productId="this.$route.query.productId"></OnlyYiLianInfo>
    <server-bank :productId="this.$route.query.productId"></server-bank>
  </div>
</template>

<script>
/**
 * 进这个页面一定是已经成功了
 */
// @ is an alias to /src
import Button from '@/components/Button.vue';
import ServerBank from '@/components/ServerBank.vue';
import OnlyYiLianInfo from '@/components/onlyYiLianInfo.vue';
import { checkStatus } from './mixin';

export default {
  name: 'GiveTrustWithSum',
  components: {
    Button,
    OnlyYiLianInfo,
    ServerBank
  },
  data() {
    return {
      danger: 'danger',
      draw: '去签约',
    };
  },
  mixins: [checkStatus],
  mounted() {
    document
      .querySelector('#app')
      .setAttribute('style', 'background-color:#fff');
    this.$store.dispatch('commonForms/checkCurrentStatus', { getInfo: false });
  },
  beforeDestroy() {
    document.querySelector('#app').removeAttribute('style');
  },
  methods: {
    gotoDownloadApp() {
      this.$store.dispatch('commonForms/nextJumpPage', {
        orderId: this.$store.state.commonForms.orderId,
      });
    },
  },
};
</script>
<style scoped>
.img {
  height: 90px;
  margin-top: 100px;
}
.congratulation {
  margin: 0;
  padding: 0 12px;
  color: #1c2438;
  font-size: 17px;
  letter-spacing: 0;
  text-align: center;
}
.icon {
  color: #f5514a;
}
.draw {
  margin-top: 100px;
  margin-bottom: 7px;
}
</style>
